import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../AuthHooks';
import { CDN_URL } from '../AuthAPI';
import { Icon, IconName } from 'react-frontier';
import { Link } from 'react-router-dom';

const Pages : {
	[x: string]: {
		key: string,
		system: string,
		url: string,
		iconName: IconName,
	}
} = {
	admin: {
		key: 'profile.navigation.admin',
		iconName: 'wrench',
		system: 'ADMIN',
		url: process.env.REACT_APP_PAGE_ADMIN || 'https://admin.arema.mx'
	},
	reports: {
		key: 'profile.navigation.reports',
		iconName: 'chart-bar',
		system: 'REPORTS',
		url: process.env.REACT_APP_PAGE_REPORTS || 'https://reportes.arema.mx'
	},
	operations: {
		key: 'profile.navigation.operations',
		iconName: 'calendar',
		system: 'OPERATIONS',
		url: process.env.REACT_APP_PAGE_OPERATIONS || 'https://operaciones.arema.mx'
	},
}

var AREMALogo = (props: { width: number })=>{
	return (
		<svg width={`${props.width}px`} height={`${props.width}px`} viewBox="0 0 1000 642.642643" version="1.1" xmlns="http://www.w3.org/2000/svg">
			<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" >
				<g id="LogoBl" transform="translate(0, 0)" fill="#000000" fill-rule="nonzero">
					<path d="M726.744129,92.0920921 L658.685421,92.0920921 C654.467263,92.0920921 650.625837,94.5045939 648.797763,98.293024 L609.531223,179.590017 L508.511596,389.60108 L407.485794,179.590017 L368.219254,98.293024 C366.39118,94.5045939 362.543578,92.0920921 358.331596,92.0920921 L290.272888,92.0920921 C282.176249,92.0920921 276.864952,100.545104 280.38523,107.8258 L315.044529,179.590017 L485.395104,534.018007 C494.708401,553.392062 522.314792,553.392062 531.621913,534.018007 L701.972488,179.590017 L736.631787,107.8258 C740.152065,100.545104 734.840768,92.0920921 726.744129,92.0920921 M0,642.642643 L0,450.279122 L0,377.024841 L39.5908105,377.024841 C55.0280762,377.024841 69.0260129,370.761785 79.1877984,360.644541 C89.4175351,350.471708 95.7617015,336.395274 95.7617015,320.861166 C95.7617015,305.327058 89.4175351,291.250624 79.1877984,281.071614 C69.0260129,270.960547 55.0280762,264.697491 39.5908105,264.697491 L0,264.697491 L0,191.443209 L0,-1.13686838e-13 L1000,-1.13686838e-13 L1000,191.443209 L1000,264.697491 L960.403012,264.697491 C944.971924,264.697491 930.973987,270.960547 920.812202,281.071614 C910.582465,291.250624 904.232121,305.327058 904.232121,320.861166 C904.232121,336.395274 910.582465,350.471708 920.812202,360.650718 C930.973987,370.761785 944.971924,377.024841 960.403012,377.024841 L1000,377.024841 L1000,450.279122 L1000,642.642643 L0,642.642643 Z" id="path40" transform="translate(500, 321.3213) scale(1, -1) translate(-500, -321.3213)"></path>
				</g>
			</g>
		</svg>
	)
}

var UserProfile = ()=>{
	var { t } = useTranslation();
	var { user, getContinueUrl, clearSaved } = useAuth();
	
	return <div className="ar login-screen profile-screen">
		<div className="contents">
			<img className='ar logo' src={`${CDN_URL}/logo/LogoH_Large.webp`} alt="AREMA" />
			<div className="title">{t('login.hello', { name: user.user.first_name })}</div>
			<div className="subtitle" style={{ marginBottom: 10 }}>
				{t('profile.subtitle')}
			</div>
			<div className="navigation">
				{/* <div className="section">{t('profile.account_section')}</div> */}
				{/* <Link className="item" to={'/password'}>
					<Icon name='key' />
					<div className="data">
						<div className="title">{t('profile.items.password_title')}</div>
						<div className="subtitle">{t('profile.items.password_subtitle')}</div>
					</div>
				</Link> */}
				<div className="item" onClick={clearSaved}>
					<Icon name='sign-out-alt' />
					<div className="data">
						<div className="title">{t('common.logout')}</div>
						<div className="subtitle">{t('profile.items.logout')}</div>
					</div>
				</div>
				<div className="section">{t('profile.navigation_section')}</div>
				<Link className="item" to={process.env.REACT_APP_PAGE || 'https://arema.mx'}>
					<AREMALogo width={32} />
					<div className="data">
						<div className="title">{t('profile.navigation.page.title')}</div>
						<div className="subtitle">{t('profile.navigation.page.subtitle')}</div>
					</div>
				</Link>
				{!!user.systems && Object.keys(Pages).map(a=>(
					!!user.systems[Pages[a].system] ? (
						<Link className="item" to={getContinueUrl(null, `${Pages[a].url}/auth`)} key={`NAV-${a}`}>
							<Icon name={Pages[a].iconName} />
							<div className="data">
								<div className="title">{t(`${Pages[a].key}.title`)}</div>
								<div className="subtitle">{t(`${Pages[a].key}.subtitle`)}</div>
							</div>
						</Link>
					) : null
				))}
			</div>
		</div>
	</div>
}

export default UserProfile;